import Swal from 'sweetalert2'
import { AxiosFacade } from '@/util/AxiosFacade'

export class swal {

    constructor() {
        this.reset();
        return this
    }

    reset = () => {
        this.data = {
            showConfirmButton: true,
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonColor: '#61CA85',
            cancelButtonColor: '#0A0030',
            denyButtonColor: '#FF434D',
            timer: 10000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        }
    }

    fire = async (args = {}) => {
        let data = this.data
        this.reset();
        return await Swal.mixin(data).fire(args)
    }

    /*
    |--------------------------------------------------------------------------
    | General
    |--------------------------------------------------------------------------
    */

    mixin = (args = {}) => {
        this.data = Object.assign({}, this.data, args)
        return this
    }

    /*
    |--------------------------------------------------------------------------
    | Types
    |--------------------------------------------------------------------------
    */

    isToast = () => {
        this.data = Object.assign({}, this.data, {
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 5000,
            text: '',
            html: ''
        })
        return this
    }

    isInfo = () => {
        this.data = Object.assign({}, this.data, { icon: 'info' })
        return this
    }

    isError = () => {
        this.data = Object.assign({}, this.data, { icon: 'error' })
        return this
    }

    isWarning = () => {
        this.data = Object.assign({}, this.data, { icon: 'warning' })
        return this
    }

    isSuccess = () => {
        this.data = Object.assign({}, this.data, { icon: 'success' })
        return this
    }

    /*
    |--------------------------------------------------------------------------
    | Actions
    |--------------------------------------------------------------------------
    */

    success = () => {
        return this.isSuccess().mixin({
            title: 'Success!',
        });
    }

    error = (errors) => {
        return this.isError().mixin({
            title: 'Uh-Oh! There was an error',
            html: AxiosFacade.flattenErrorResponsetoString(errors),
        });
    }

    confirm = () => {
        return this.isWarning().mixin({
            title: 'Are you sure?',
            showDenyButton: true,
            confirmButtonText: 'Yes!',
            denyButtonText: 'No'
        });
    }

    confirmAction = (confirmText) => {
        return this.confirm().mixin({
            title: 'Are you sure?',
            showDenyButton: true,
            confirmButtonText: confirmText || 'Yes!',
            denyButtonText: 'Cancel',
        });
    }

    confirmDelete = (victim) => {
        this.confirm().mixin({
            icon: '',
            iconHtml: `<i class="far fa-trash" style="color: #FC4A4A"></i>`,
            denyButtonText: 'No, thanks',
            confirmButtonColor: '#FF5552',
            denyButtonColor: '#0A0030',
            showCloseButton: true,
        });
        if (victim) {
            this.data['title'] = 'Delete "' + victim + '"?'
        }
        return this
    }

    created = (target) => {
        return this.isSuccess().mixin({
            title: 'Created!',
            text: target ? '"' + target + '" was created!' : 'The resource has been created.',
        });
    }

    enableDisable = (active) => {
        return this.confirm().mixin({
            icon: '',
            iconHtml: `<i class="far fa-power-off" style="color: ${active ? '#FC4A4A' : '#5CCA82'}"></i>`,
            title: '',
            confirmButtonText: active ? 'Pause' : 'Activate',
            confirmButtonColor: '#0A0030',
            showCancelButton: false,
            showDenyButton: false,
            showCloseButton: true,
            timer: false,
        })
    }

    saved = (target) => {
        return this.isSuccess().mixin({
            title: 'Saved!',
            text: target ? '"' + target + '" was saved!' : 'The resource has been saved.',
        });
    }

    updated = (target) => {
        return this.isSuccess().mixin({
            title: 'Updated!',
            text: target ? '"' + target + '" was updated!' : 'The resource has been updated.',
        });
    }

    deleted = (victim) => {
        this.isSuccess().mixin({
            title: 'Deleted!',
            text: victim ? '' + victim + ' was deleted!' : 'The resource has been deleted.',
        });
        return this
    }

    duplicated = (target) => {
        return this.isSuccess().mixin({
            title: 'Duplicated!',
            text: target ? '"' + target + '" was duplicated!' : 'The resource has been duplicated.',
        });
    }

    loading = () => {
        return this.isInfo().mixin({
            title: 'Please Wait... Processing',
            timer: false,
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading() },
        });
    }

    close = () => {
        Swal.close()
    }

}